export default {"src":"/_next/static/media/vertical-squiggle.2e7d6854.svg","height":481,"width":232,"blurWidth":0,"blurHeight":0};